// pt-BR for the integration module catalogue (complete for every key of en-modules.ts, checked by the type).
import type { enModules } from "./en-modules.ts";

export const ptBRModules: Record<keyof typeof enModules, string> = {
  "integrations.tab.catalog": "Catálogo",
  "modules.subtitle": "Centralize os serviços que seus agentes e projetos usam: canais de mensagem, provedores de IA, pagamentos e automações.",
  "modules.search": "Buscar integrações",
  "modules.searchPlaceholder": "Buscar integração...",
  "modules.filters": "Filtrar por categoria",
  "modules.filter.all": "Todos",
  "modules.category.canal": "Canal de Comunicação",
  "modules.category.ia": "Inteligência Artificial",
  "modules.category.pagamento": "Gateway de Pagamento",
  "modules.category.automacao": "Automação",
  "modules.category.dados": "Dados",
  "modules.category.infra": "Infraestrutura",
  "modules.category.outros": "Outros",
  "modules.comingSoon": "Em breve",
  "modules.comingSoonHint": "Ainda não disponível",
  "modules.instancesOne": "1 instância",
  "modules.instancesMany": "{n} instâncias",
  "modules.versionTitle": "Módulo {module} · versão {version}",
  "modules.loading": "Carregando o catálogo de integrações",
  "modules.loadFailed": "Não foi possível carregar o catálogo de integrações",
  "modules.emptyTitle": "Ainda não há integrações no catálogo",
  "modules.emptyBody": "Nenhum módulo está instalado nesta versão. Nada aqui é simulado.",
  "modules.noMatchTitle": "Nenhuma integração encontrada",
  "modules.noMatchBody": "Tente outro termo ou escolha “Todos” nos filtros.",
  "modules.clearFilters": "Limpar busca e filtros",
  "modules.resultsCount": "{n} integrações exibidas",
  "modules.detail.facts": "Detalhes do módulo",
  "modules.detail.module": "Módulo",
  "modules.detail.version": "Versão",
  "modules.detail.maturity": "Maturidade",
  "modules.detail.scope": "Escopo",
  "modules.detail.category": "Categoria",
  "modules.detail.capabilities": "Capacidades",
  "modules.detail.operations": "Operações",
  "modules.detail.none": "Nenhuma declarada",
  "modules.detail.unknown": "Não informado",
  "modules.maturity.experimental": "Experimental",
  "modules.maturity.beta": "Beta",
  "modules.maturity.stable": "Estável",
  "modules.maturity.deprecated": "Descontinuado",
  "modules.scope.instalacao": "Toda a instalação",
  "modules.scope.conta": "Por conta (organização)",
  "modules.scope.conexao": "Por conexão",
  "modules.state.draft": "Rascunho",
  "modules.state.active": "Ativa",
  "modules.state.disabled": "Inativa",
  "modules.state.error": "Com erro",
  "modules.action.label": "{action}: {name}",
  "modules.panel.version": "Versão {version}",
  "modules.panel.standalone": "Funciona sozinha: não depende de outra integração.",
  "modules.panel.dependsOn": "Depende de {list}.",
  "modules.panel.needsRole": "pelo menos {min} {role}",
  "modules.panel.role.provedor-de-ia": "provedor de IA",
  "modules.panel.about": "Sobre esta integração",
  "modules.panel.accountsIntro": "Conecte uma ou mais contas de {name} e dê a cada uma um nome que sua equipe reconheça.",
  "modules.panel.vaultNote": "A chave fica no cofre do sistema e nunca volta para a tela.",
  "modules.panel.notExecutable.channel_module": "Este canal é conectado por quem administra a instalação; ainda não dá para configurá-lo por este painel.",
  "modules.panel.notExecutable.host_executed_card": "Este card é configurado pelo próprio sistema e não usa uma conta própria.",
  "modules.panel.notExecutable.other": "Ainda não dá para conectar esta integração por este painel.",
  "modules.panel.configLoadFailed": "Não foi possível carregar as configurações desta integração",
  "modules.panel.accounts": "Contas",
  "modules.panel.accountsEmptyTitle": "Nenhuma conta de {name} cadastrada",
  "modules.panel.accountsEmptyBody": "Adicione a primeira conta abaixo para começar a usar esta integração.",
  "modules.panel.readOnly": "Quem cadastra e altera as contas é o administrador.",
  "modules.panel.loadFailed": "Não foi possível carregar as contas",
  "modules.panel.keyStored": "Chave gravada",
  "modules.panel.keyStoredHint": "Chave gravada ({hint})",
  "modules.panel.keyMissing": "Sem chave",
  "modules.panel.keyRevoked": "Chave revogada",
  "modules.panel.lastTestOk": "Último teste passou: {summary}",
  "modules.panel.lastTestFailed": "Último teste falhou: {summary}",
  "modules.panel.neverTested": "Ainda não testada",
  "modules.panel.edit": "Editar",
  "modules.panel.test": "Testar",
  "modules.panel.activate": "Ativar",
  "modules.panel.deactivate": "Desativar",
  "modules.panel.delete": "Excluir",
  "modules.panel.activationUnavailable": "A ativação desta integração ainda não está disponível aqui.",
  "modules.panel.activationNeedsTest": "Passe no teste para ativar esta conta.",
  "modules.panel.activateTitle": "Ativar “{name}”?",
  "modules.panel.activateBody": "A partir de agora, agentes e projetos podem fazer chamadas reais a {provider} com esta conta. Você pode desativá-la quando quiser.",
  "modules.panel.activated": "Conta “{name}” ativada.",
  "modules.panel.deactivated": "Conta “{name}” desativada.",
  "modules.panel.deleteTitle": "Excluir a conta “{name}”?",
  "modules.panel.deleteBody": "A chave é apagada do cofre do sistema e a conta some de todas as listas. O histórico de testes e de uso fica guardado para auditoria. Isso não pode ser desfeito.",
  "modules.panel.deleteConfirm": "Excluir conta",
  "modules.panel.deleted": "Conta “{name}” excluída.",
  "modules.panel.deleteRefused.instance_active": "Desative esta conta antes de excluí-la.",
  "modules.panel.deleteRefused.instance_in_use": "Esta conta está em uso por uma conexão de modelo ou por outra integração. Remova esse vínculo primeiro.",
  "modules.panel.testPassed": "Teste aprovado: {summary}",
  "modules.panel.testFailed": "O teste falhou: {summary}",
  "modules.panel.testRefused": "Não foi possível rodar o teste.",
  "modules.panel.addTitle": "Adicionar conta de {name}",
  "modules.panel.addBody": "Dê um nome para reconhecer esta conta depois (por exemplo, o setor ou o projeto) e cole a chave. O sistema testa a chave ao salvar.",
  "modules.panel.addBodyNoSecret": "Dê um nome para reconhecer esta conta depois e preencha as configurações. O sistema testa tudo ao salvar.",
  "modules.panel.editTitle": "Editar “{name}”",
  "modules.panel.editBody": "Altere o nome ou as configurações. Deixe a chave em branco para manter a atual.",
  "modules.panel.accountName": "Nome da conta",
  "modules.panel.accountNameHint": "Aparece onde alguém escolhe esta conta: agentes, projetos e modelos.",
  "modules.panel.accountNamePlaceholder": "Ex.: {name} da empresa",
  "modules.panel.keepKey": "Deixe em branco para manter a chave atual.",
  "modules.panel.nameRequired": "Dê um nome para a conta.",
  "modules.panel.fieldRequired": "Preencha “{label}”.",
  "modules.panel.tooShort": "Precisa ter pelo menos {n} caracteres.",
  "modules.panel.tooLong": "Pode ter no máximo {n} caracteres.",
  "modules.panel.optional": "opcional",
  "modules.panel.choose": "Escolha…",
  "modules.panel.yes": "Sim",
  "modules.panel.no": "Não",
  "modules.panel.saveAndTest": "Salvar e testar",
  "modules.panel.save": "Salvar",
  "modules.panel.connected": "Conta “{name}” conectada. {summary}",
  "modules.panel.saved": "Conta “{name}” salva.",
  "modules.panel.keyRefused": "Conta “{name}” salva, mas o teste falhou: {summary}",
  "modules.panel.savedTestBlocked": "Conta “{name}” salva, mas o teste não pôde rodar.",
  "modules.panel.checkFields": "Confira os campos destacados.",
  "modules.panel.whereKey": "Onde encontro a chave?",
  "modules.panel.help.1": "Entre em {name} com a conta da empresa.",
  "modules.panel.help.2": "Abra a área de chaves de API e crie uma chave só para este sistema.",
  "modules.panel.help.3": "Copie a chave na hora (muitos provedores só a mostram uma vez) e cole acima.",
  "modules.panel.help.4": "Confira se a conta tem crédito ou plano ativo: sem isso, as chamadas são recusadas.",
  "modules.panel.technical": "Detalhes técnicos",
  "modules.panel.versionInUse": "Versão em uso: {version}",
  "modules.panel.copyDiagnostic": "Copiar diagnóstico",
  "modules.panel.diagnosticCopied": "Diagnóstico copiado (sem nenhuma chave).",
  "modules.panel.copyFailed": "Não foi possível copiar: o navegador bloqueou a área de transferência.",
};
